import {Component, OnInit} from '@angular/core';
import {faCircleCheck, faCircleXmark, faTimes} from "@fortawesome/pro-solid-svg-icons";
import {ToastService} from "../../../service/toast.service";

@Component({
	selector: 'joy-toast',
	template: `
		<div class="toast-container" [ngClass]="{show: queue.length > 0}">
			<ng-container *ngFor="let item of queue">
				<div class="toast" 
					 [class.success]="item.type === 'success'" 
					 [class.error]="item.type === 'error'"
					 [class.has-actions]="item.actions && item.actions.length > 0">
					<fa-icon class="toast-icon" *ngIf="item.show_icon" [icon]="item.fa_icon || icon_map[item.type]"></fa-icon>
					<div class="msg">
						{{ item.msg }}
					</div>
					<div class="toast-actions" *ngIf="item.actions && item.actions.length > 0">
						<button 
							*ngFor="let action of item.actions" 
							class="toast-action-btn"
							[class]="action.class || 'btn-secondary'"
							(click)="handleAction(item, action)">
							{{ action.label }}
						</button>
					</div>
					<button 
						*ngIf="item.dismissible !== false" 
						class="toast-dismiss-btn" 
						(click)="item.remove()"
						aria-label="Dismiss">
						<fa-icon [icon]="faTimes"></fa-icon>
					</button>
				</div>
			</ng-container>
		</div>
	`,
	styleUrls: ['./joy-toast.component.scss']
})

export class JoyToastComponent implements OnInit {

	queue = [];

	icon_map = {
		success: faCircleCheck,
		error: faCircleXmark,
	};

	faTimes = faTimes;

	constructor(
		public toast: ToastService,
	) {
	}

	ngOnInit() {
		this.toast.callback = (data) => this.add(data);
	}


	add(data: any) {
		let host = this;
		return new Promise((resolve, reject) => {
			data.msg = data.msg || '';
			data.interval = data.interval || 3000;
			data.type = data.type || 'success';
			data.persistent = data.persistent || false;
			data.dismissible = data.dismissible !== false; // Default to true
			data.actions = data.actions || [];
			data.show_icon = data.show_icon || false;
			data.fa_icon = data.fa_icon || null;

			let default_data = {
				msg: '',
				interval: 3000,
				type: 'success',
				persistent: false,
				dismissible: true,
				actions: [],
				...data,
				interval_id: null,
				show() {
					console.log('show toast:', this.msg);
					if (this.interval_id || this.persistent) {
						return;
					}

					this.interval_id = setTimeout(() => {
						this.remove();
					}, this.interval);
				},
				remove() {
					console.log('remove toast:', this.msg);
					clearTimeout(this.interval_id);
					this.interval_id = null;
					let index = host.queue.indexOf(this);
					if (index > -1) {
						host.queue.splice(index, 1);
						resolve(true);
					}
				},
			};

			host.queue.push(default_data);

			console.log('Toast queue:', host.queue);

			default_data.show();

		});
	}

	handleAction(item: any, action: any) {
		console.log('Toast action clicked:', action.label);
		if (action.callback) {
			action.callback();
		}
		if (action.dismiss !== false) {
			item.remove();
		}
	}
}

export interface ToastParams {
	msg: string;
	interval?: number | null;
	type?: string | null;
	persistent?: boolean;
	dismissible?: boolean;
	actions?: { label: string, callback: () => void, class?: string, dismiss?: boolean }[];
	show_icon?: boolean;
	fa_icon?: any;
}